// Import libraries and functionality
import classnames from 'classnames';
import { v4 as uuidv4 } from 'uuid';
const merge = require('deepmerge');
const diff = require('deep-object-diff').diff;
const { Spinner } = wp.components;
import { Debug, getThemes, updateCustomThemes } from '../utility';

//  Import core block libraries
const { withState } = wp.compose;
const { Button, Modal, TextControl, CheckboxControl } = wp.components;
const { __ } = wp.i18n;
const { Component, Fragment } = wp.element;

const preserve_attr = [
	'id',
	'unique_id',
	'group',
	'template',
	'gutenberg_bl',
	'faqPostId',
	'faqGroupId',
	'faq_group_toggle',
	'faq_post_title',
	'center_faq_post_title',
	'description',
	'expand_first_item',
	'accordion_mode',
	'_factory_labels',
];
export default class DuplicateThemeModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isDirty: false,
			isDirtyModal: false,
			isParseError: false,
			parseErrorMessage: '',
			showSpinner: false,
			submitBtnLabel: 'Create Custom Theme',
			modalCustomName: this.setModalCustomName(),
			modalCustomDescription: props.faqThemeDescription,
			modalCustomSwitchImmediately: true,
		};

		//console.log('CONSTRUCTOR!');

		// this.open = this.open.bind(this);
		this.setModalCustomName = this.setModalCustomName.bind(this);
		this.close = this.close.bind(this);
		this.save = this.save.bind(this);
		this.cancelIsDirtyModal = this.cancelIsDirtyModal.bind(this);
		this.discardIsDirtyModal = this.discardIsDirtyModal.bind(this);
	}

	componentDidMount() {
		//console.log('componentDidMount <DuplicateThemeModal />');
	}

	componentDidUpdate(prevProps, prevState) {
		// @todo need to allow multiple params or pass in an array?
		//console.log('*** STATE: ', this.state, prevState);

		// update modal theme label when changed but only if modal is not open. e.g. if theme switched
		if (
			!this.props.isDuplicateModalOpen &&
			this.props.faqThemeLabel !== prevProps.faqThemeLabel
		) {
			this.setState({ modalCustomName: this.setModalCustomName() });
		}

		// update modal theme description when changed but only if modal is not open
		if (
			!this.props.isDuplicateModalOpen &&
			this.props.faqThemeDescription !== prevProps.faqThemeDescription
		) {
			this.setState({
				modalCustomDescription: this.props.faqThemeDescription,
			});
		}
	}

	setModalCustomName() {
		const customThemeSuffix = this.props.faqThemeLabel.includes('(custom)')
			? ''
			: '(custom)';

		//console.log('setModalCustomName: ', this.props.faqThemeLabel.includes(customThemeSuffix), `${this.props.faqThemeLabel} ${customThemeSuffix}`);
		return `${this.props.faqThemeLabel} ${customThemeSuffix}`;
	}

	close(e) {
		if (this.state.isDirty) {
			this.setState({ isDirtyModal: true });
		} else {
			// Do we need to set state here if isDirty === false as state should be unchanged?
			const state = {
				modalCustomName: this.setModalCustomName(),
				modalCustomDescription: this.props.faqThemeDescription,
				isParseError: false,
			};
			this.setState(state, function () {
				this.props.setDuplicateModalOpenStatus(false);
			});
		}
	}

	// Create custom theme, save, and close modal
	save(e) {
		const { coreThemes, endpoint } = this.props;

		// Todo: add extra data integrity check here, such as checking each object has same prop names and number of props, or catch error and display warning and not close textbox.

		// Make sure the theme title should not be empty.
		if ('' === this.state.modalCustomName.trim()) {
			this.setState({
				isParseError: true,
				parseErrorMessage: `FAQ theme name cannot be empty!`,
				showSpinner: false,
			});
		} else if (
			this.props.faqThemeLabel === this.state.modalCustomName.trim()
		) {
			// Make sure that new custom theme name is different to current theme name.
			// @TODO also need to check against other theme names too, it's a bit basic right now.
			this.setState({
				isParseError: true,
				parseErrorMessage: `Theme name matches current theme. Please make it unique.`,
				showSpinner: false,
			});
		} else {
			// @TODO We're setting isParseError to false twice here. Can't we just set it once after theme has been duplicated?
			// i.e. don't set state with callback, just call the async function and then reset isParseError in the setState call after the theme has been created
			this.setState(
				{
					isParseError: false,
					showSpinner: true,
					submitBtnLabel: 'Creating Custom Theme',
				},
				async function () {
					// update custom theme with data from modal and generated ID (name)
					const id = 'id-' + uuidv4();
					const name = this.state.modalCustomName.trim();
					const description = this.state.modalCustomDescription;
					const switchThemeImmediately =
						this.state.modalCustomSwitchImmediately;
					const tmpCustomTheme = {};
					tmpCustomTheme[id] = {};

					const parentTheme = this.props.attributes._parent_theme;
					const diffObj = merge.all([
						coreThemes.default.faq_attributes,
						coreThemes[parentTheme].faq_attributes,
					]);

					const diffAttr = diff(diffObj, this.props.attributes);
					preserve_attr.forEach(function (attr) {
						delete diffAttr[attr];
					});
					//console.log('Custom theme attributes: ', diffAttr);

					// tidy up and make sure we're only saving the style attributes we want
					delete diffAttr.id;
					delete diffAttr.theme;
					delete diffAttr.gutenberg_bl;
					delete diffAttr.faq_theme_select;
					delete diffAttr.faqPostId;
					delete diffAttr.faqGroupId;
					delete diffAttr.faqThemeCustomizedStatus;
					diffAttr._parent_theme = parentTheme;
					diffAttr._theme_type = 'custom';

					tmpCustomTheme[id].name = id;
					tmpCustomTheme[id].label = name;
					tmpCustomTheme[id].description = description;
					tmpCustomTheme[id].faq_attributes = merge(diffAttr, {});
					tmpCustomTheme[id].type = 'custom';
					//tmpCustomTheme[id].edit_status = false;
					//tmpCustomTheme[id].customized = false;

					//console.log('TMP CUSTOM THEME:', tmpCustomTheme);
					//console.log('DIFF OBJECTS:', this.props.attributes._parent_theme, diffObj, this.props.attributes);
					//console.log('DIFF:', diffAttr);
					//return;

					const existingCustomThemes = await getThemes(endpoint);
					const newCustomThemes = merge(
						JSON.parse(existingCustomThemes),
						tmpCustomTheme
					);

					//console.log("output: ", JSON.parse(existingCustomThemes), tmpCustomTheme);
					const updatedCustomThemes = await updateCustomThemes(
						JSON.stringify(newCustomThemes),
						endpoint
					);

					//console.log(['AFTER', JSON.parse(existingCustomThemes), tmpCustomTheme, newCustomThemes]);
					//console.log(['CREATED', JSON.stringify(updatedCustomThemes)]);

					// reset modal fields ready for when it's displayed again, and close modal
					const state = {
						modalCustomName: this.setModalCustomName(),
						modalCustomDescription: this.props.faqThemeDescription,
						modalCustomSwitchImmediately: true,
						isDirtyModal: false,
						isDirty: false,
						isParseError: false,
						showSpinner: false,
						submitBtnLabel: 'Create Custom Theme',
						parseErrorMessage: '',
					};
					this.setState(state, () => {
						//if 'Switch to new theme?' checkbox selected then switch to new custom theme immediately

						const tmpTheme = switchThemeImmediately
							? { value: id, label: name }
							: null;
						this.props.updateThemeList(tmpTheme);

						this.props.setDuplicateModalOpenStatus(false);

						//console.log('CREATE THEME: ', switchThemeImmediately);

						//this.props.updateThemeList({ value: id, label: name }, switchThemeImmediately);

						// if(switchThemeImmediately) {
						// 	this.props.updateThemeList({ value: id, label: name });
						// } else {
						// 	this.props.updateThemeList({ value: id, label: name }, true);
						// }
						//const tmpTheme = switchThemeImmediately ? { value: id, label: name } : null;
						//this.props.updateThemeList(tmpTheme);
						//this.props.setDuplicateModalOpenStatus(false);
					});
				}
			);
		}

		// const state = { modalCustomName: this.setModalCustomName(), modalCustomDescription: this.props.faqThemeDescription, isParseError: false };
		// this.setState(state, function () {
		//     this.props.setDuplicateModalOpenStatus(false);
		// });
	}

	// allow user to save changes in 'Edit Data' modal
	cancelIsDirtyModal(e) {
		this.setState({ isDirtyModal: false });
	}

	// discard changes in is dirty modal
	discardIsDirtyModal(e) {
		//console.log('DISCARD CHANGES');

		const state = {
			modalCustomName: this.setModalCustomName(),
			modalCustomDescription: this.props.faqThemeDescription,
			modalCustomSwitchImmediately: true,
			isDirtyModal: false,
			isDirty: false,
			isParseError: false,
			parseErrorMessage: '',
		};
		this.setState(state, function () {
			this.props.setDuplicateModalOpenStatus(false);
		});

		//this.setState({ isDirtyModal: false, isDirty: false, parseErrorMessage: '' });
		//setState({ isDirtyModal: false, isDuplicateModalOpen: false, isDirty: false, parseErrorMessage: '' });
	}

	render() {
		const {
			modalCustomName,
			modalCustomDescription,
			modalCustomSwitchImmediately,
			isParseError,
			parseErrorMessage,
			isDirtyModal,
			showSpinner,
			submitBtnLabel,
			isDirty,
		} = this.state;

		const ParseErrorMessage = () => (
			<div style={{ fontStyle: 'italic' }} className="parse-error">
				<span className="dashicons dashicons-warning"></span>{' '}
				{parseErrorMessage}
			</div>
		);

		return (
			<Fragment>
				{this.props.isDuplicateModalOpen && (
					<Modal
						title="Create New Custom Theme"
						shouldCloseOnClickOutside={false}
						onRequestClose={this.close}
						className="modal-duplicate-faq-theme"
					>
						<div className="child-page-listing">
							<div className="grid-container">
								<Fragment>
									<div style={{ marginBottom: '15px' }}>
										Create a new theme based on the existing
										&quot;{this.props.faqThemeLabel}&quot;
										theme.
									</div>
									{isParseError && <ParseErrorMessage />}
									<TextControl
										label="Theme Name"
										value={modalCustomName}
										onChange={(text) => {
											this.setState({
												isParseError: false,
												isDirty: true,
												modalCustomName: text,
											});
										}}
									/>
									<div style={{ marginTop: '15px' }}></div>
									<TextControl
										label="Theme Description (optional)"
										value={modalCustomDescription}
										onChange={(text) => {
											this.setState({
												isDirty: true,
												modalCustomDescription: text,
											});
										}}
									/>
									<div style={{ marginTop: '25px' }}></div>
									<CheckboxControl
										help={`Switch to new theme immediately, or uncheck to keep editing the current customised theme.`}
										label="Switch to new theme?"
										checked={modalCustomSwitchImmediately}
										onChange={() =>
											this.setState({
												isDirty: true,
												modalCustomSwitchImmediately:
													!modalCustomSwitchImmediately,
											})
										}
									/>
									<div style={{ marginTop: '25px' }}></div>
									{isDirtyModal && (
										<div>
											<Modal
												title="Unsaved Changes"
												isDismissable={false}
												className="modal-duplicate-faq-theme-unsaved"
											>
												<div className="modal-discard-changes">
													Discard changes, or go back
													to edit/save custom theme
													details?
												</div>
												<div className="modal-buttons">
													<Button
														variant="secondary"
														onClick={
															this
																.discardIsDirtyModal
														}
													>
														Discard
													</Button>
													<Button
														variant="secondary"
														onClick={
															this
																.cancelIsDirtyModal
														}
													>
														Back
													</Button>
												</div>
											</Modal>
										</div>
									)}
								</Fragment>
							</div>
						</div>
						<div className="modal-buttons">
							<Button variant="secondary" onClick={this.close}>
								Cancel
							</Button>
							{showSpinner && (
								<div className="modal-spinner">
									<Spinner />
								</div>
							)}
							<Button variant="secondary" onClick={this.save}>
								{submitBtnLabel}
							</Button>
						</div>
					</Modal>
				)}
			</Fragment>
		);
	}
}
